<template>
  <v-navigation-drawer temporary :mini-variant="miniVariant" :clipped="clipped" :value="drawer" @input="change" enable-resize-watcher>
    <v-list>

      <v-list-tile @click.native="miniVariant = !miniVariant">
        <v-list-tile-action>
          <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Meniu ingust</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click.native="toggleLight">
        <v-list-tile-action>
          <v-icon class="app-light">{{!light ? 'lightbulb_outline' : 'wb_incandescent'}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Lumina</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-for="(item, i) in items" :key="i" :to="item.link" v-if="displayLinkToRoute(item)">
        <v-list-tile-action>
          <v-icon v-html="item.icon"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    computed: {
      light () {
        return this.$store.getters.appLight
      },
      clipped () {
        return this.$store.getters.appClipped
      },
      miniVariant: {
        get () {
          return this.$store.getters.appMini
        },
        set () {
          this.$store.commit('toggleMini')
        }
      },
      drawer: {
        get () {
          return this.$store.getters.appDrawer
        },
        set () {
          // this.$store.commit('toggleDrawer')
        }
      },
      items () {
        return this.$store.getters.appMenuItems
      },
      auth () {
        return this.$store.getters.getUser
      }
    },
    methods: {
      change (val) {
        val ? this.$store.commit('openDrawer') : this.$store.commit('closeDrawer')
      },
      toggleLight () {
        this.$store.commit('toggleLight')
      },
      displayLinkToRoute (item) {
        return item.auth === undefined || (item.auth === false && this.auth === null) || (item.auth && this.auth && !item.admin) || (item.auth && this.auth && item.admin && this.auth.admin)
      }
    }
  }
</script>

<style lang="stylus">
  .application--light {
    .app-light {
      transform: rotate(180deg) !important;
      color: #ffc107!important;
    }
  }
  .application--dark {
    .app-light {
      color: #b3d4fc!important;
    }
  }
</style>



// WEBPACK FOOTER //
// Drawer.vue?6091c4fe